import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import CreateButton from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDDashboardBoilerplate/CRUDHeader/CreateButton/CreateButton";
import CRUDTable from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTable";
import CRUDTableHeader from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDTableHeader";
import CRUDth from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDth/CRUDth";
import CRUDTableRow from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableRow/CRUDTableRow";
import ImageCell from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ImageCell/ImageCell";
import EditButton from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/EditButton/EditButton";
import DeleteButton from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/DeleteButton/DeleteButton";
import Modal from "../../../../Partials/Elements/Modal/Modal";
import CRUDDeleteBoilerPlate from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDDeleteBoilerPlate/CRUDDeleteBoilerPlate";
import { CaseStudy_IMAGES_API } from "../../../../../Utilities/APIs";
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance";
import ViewButton from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/ViewButton/ViewButton";
import ViewCaseStudyImage from "./CaseStudiesForms/ViewCaseStudyImage";
import UpdateCaseStudyImage from "./CaseStudiesForms/UpdateCaseStudyImage";
import CreateCaseStudyImage from "./CaseStudiesForms/CreateCaseStudyImage";

function CaseStudyImage() {
  const [CaseStudyImage, setCaseStudyImage] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [showView, setShowView] = useState(false);
  const [targetID, setTargetID] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showDeleteSection, setShowDeleteSection] = useState(false);
  const [toggleFetch, setToggleFetch] = useState(false);

  const { id } = useParams();
  const axiosInstance = useAxiosInstance();

  useEffect(() => {
    async function fetchAndSetProducts() {
      const { data } = await axiosInstance.get(
        CaseStudy_IMAGES_API + "allCaseStudyImageByCaseStudyId/" + id
      );
      setCaseStudyImage(data);
      console.log("data", data);
    }
    fetchAndSetProducts();
  }, [toggleFetch, id, axiosInstance]);

  function handleClose() {
    setShowModal(false);
    setShowCreateForm(false);
    setShowView(false);
    setShowUpdateForm(false);
    setShowDeleteSection(false);
  }

  function triggerFetch() {
    setToggleFetch((prevState) => !prevState);
  }
  return (
    <>
      <div className="crud_holder">
        <div className="body_header">
          <h1 className="heading">{`Items (${CaseStudyImage?.length} in total)`}</h1>
          <CreateButton
            screenTopicSingular="Video Or Image"
            setShowModal={setShowModal}
            setShowCreateForm={setShowCreateForm}
          />
        </div>
        <CRUDTable>
          <CRUDTableHeader>
            <CRUDth th="Image" />
            <CRUDth th="Actions" />
          </CRUDTableHeader>
          <tbody>
            {CaseStudyImage?.map((product) => (
              <CRUDTableRow key={product._id}>
                <ImageCell imgSrc={product.image} />

                <td className="action_button_cell">
                  <ViewButton
                    setShowModal={setShowModal}
                    setShowViewSection={setShowView}
                    targetID={product._id}
                    setTargetID={setTargetID}
                  />

                  <EditButton
                    setShowModal={setShowModal}
                    setShowUpdateForm={setShowUpdateForm}
                    targetID={product._id}
                    setTargetID={setTargetID}
                  />
                  <DeleteButton
                    setShowModal={setShowModal}
                    setShowDeleteSection={setShowDeleteSection}
                    targetID={product._id}
                    setTargetID={setTargetID}
                  />
                </td>
              </CRUDTableRow>
            ))}
          </tbody>
        </CRUDTable>
      </div>
      {showModal && (
        <Modal
          view
          handleClose={handleClose}
          modalHeading={
            (showCreateForm && `Create Video Or Image`) ||
            (showUpdateForm && `Update Video Or Image `) ||
            (showDeleteSection && `Delete Video Or Image`)
          }
        >
          {showCreateForm && (
            <CreateCaseStudyImage
              setShowCreateForm={setShowCreateForm}
              setShowModal={setShowModal}
              triggerFetch={triggerFetch}
              targetID={targetID}
              CaseStudyId={id}
            />
          )}
          {showUpdateForm && (
            <UpdateCaseStudyImage
              targetID={targetID}
              setShowUpdateForm={setShowUpdateForm}
              setShowModal={setShowModal}
              triggerFetch={triggerFetch}
              CaseStudyId={id}
            />
          )}

          {showDeleteSection && (
            <CRUDDeleteBoilerPlate
              api={CaseStudy_IMAGES_API}
              targetID={targetID}
              setShowModal={setShowModal}
              setShowDeleteSection={setShowDeleteSection}
              hasName
              triggerFetch={triggerFetch}
            />
          )}
        </Modal>
      )}

      {showModal && showView && (
        <Modal
          view
          handleClose={handleClose}
          modalHeading={showView && `View Video Or Image`}
        >
          <ViewCaseStudyImage targetID={targetID} />
        </Modal>
      )}
    </>
  );
}

export default CaseStudyImage;
